import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Linking,
} from "react-native";
import { AppText } from "@/components/AppText";
import { Ionicons } from "@expo/vector-icons";
import { storageUtils } from "@/utils/storage";
import { APP_BASE_URL } from "@/constants/Configs";
import { FontFamilies } from "@/constants/Typography";

interface UpgradeToUnlimitedCardProps {}

interface UnlimitedBenefitItemProps {
  text: string;
}

const UnlimitedBenefitItem: React.FC<UnlimitedBenefitItemProps> = ({
  text,
}) => {
  return (
    <View style={styles.benefitItem}>
      <View style={styles.checkContainer}>
        <Ionicons name="checkmark" size={16} color="#FFFFFF" />
      </View>
      <Text style={styles.benefitText}>{text}</Text>
    </View>
  );
};

const UpgradeToUnlimitedCard: React.FC<UpgradeToUnlimitedCardProps> = ({}) => {
  const benefits = [
    "0% fee on automated refunds",
    "$0 filing fee for class action claims",
    "Only $7/month ($84 billed annually)",
  ];

  const onPressUpgrade = async () => {
    const sessionId = await storageUtils.getSessionId();
    Linking.openURL(`${APP_BASE_URL}/upgrade?sessionId=${sessionId}`);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Activate Sparrow Unlimited</Text>

      <View style={styles.benefitsContainer}>
        {benefits.map((benefit, index) => (
          <UnlimitedBenefitItem key={index} text={benefit} />
        ))}
      </View>

      <TouchableOpacity style={styles.upgradeButton} onPress={onPressUpgrade}>
        <AppText style={styles.upgradeButtonText}>Upgrade to Unlimited</AppText>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 20,
    marginTop: 24,
  },
  title: {
    fontSize: 18,
    fontFamily: FontFamilies.InterTight.SemiBold,
    color: "#1F2937",
    marginBottom: 20,
    lineHeight: 24,
  },
  benefitsContainer: {
    marginBottom: 24,
  },
  benefitItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
  },
  checkContainer: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: "#22C55E",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  benefitText: {
    fontSize: 16,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#1F2937",
    flex: 1,
  },
  upgradeButton: {
    backgroundColor: "#22C55E",
    borderRadius: 24,
    paddingVertical: 16,
    paddingHorizontal: 24,
    alignItems: "center",
    justifyContent: "center",
  },
  upgradeButtonText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontFamily: FontFamilies.InterTight.SemiBold,
  },
});

export default UpgradeToUnlimitedCard;
